import useUrlShortener from '@jupiterone/jupiter-web-toolkit/src/clients/useUrlShortener';

interface FormatQueryUrlOptions {
  query?: string;
  questionId?: string;
  variables?: any;
}

const useFormatQueryUrl = () => {
  const { compressUrl } = useUrlShortener();
  async function formatQueryUrl({
    query,
    questionId,
    variables,
  }: FormatQueryUrlOptions): Promise<string> {
    const url = window.location.origin + '/landing';

    if (query) {
      const substitutedQuery = variables
        ? query.replace(
            /\${.*}/g,
            (match) => `"${variables[match.slice(2, -1)]}"`
          )
        : query;

      const { url: compressedUrl } = await compressUrl({
        baseUrl: url,
        queryParameters: {
          query: substitutedQuery,
        },
      });

      return compressedUrl;
    } else if (questionId) {
      const encodedQuestionId = encodeURIComponent(questionId).replace(
        /'/g,
        '%27'
      );
      return `${url}?question=${encodedQuestionId}`;
    }
    return url;
  }
  return { formatQueryUrl };
};

export default useFormatQueryUrl;
